/** Loading placeholders. Prefer these over "Loading..." text. */

export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`animate-pulse rounded bg-slate-200/70 ${className}`} />;
}

/** Placeholder rows for a table body while it loads. */
export function SkeletonRows({ rows = 6, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, r) => (
        <tr key={r} className="border-b border-slate-100">
          {Array.from({ length: cols }, (_, c) => (
            <td key={c} className="px-3 py-3">
              <Skeleton className={`h-3.5 ${c === 0 ? 'w-40' : c % 2 ? 'w-24' : 'w-16'}`} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

/** Placeholder for a card / panel of stacked lines. */
export function SkeletonCard({ lines = 4 }: { lines?: number }) {
  return (
    <div className="card p-5 space-y-3">
      <Skeleton className="h-4 w-1/3" />
      {Array.from({ length: lines - 1 }, (_, i) => (
        <Skeleton key={i} className={`h-3 ${i % 2 ? 'w-2/3' : 'w-5/6'}`} />
      ))}
    </div>
  );
}
